import React from "react";
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import MarketoFormComponent from '../marketo/marketoFormComponent';
import '../../sass/components/flexibleModules/_components.UnsubscribePageComponent.scss';

const UnsubscribePageComponent = ({ indItem, data }) => {
    return (
        <div className="cp-flexibleUnsubscribe l--genericpadding l--sectionPadding" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-flexibleUnsubscribe__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                <div className="cp-flexibleUnsubscribe__form">
                    <Link to={`/`}>
                        <StaticImage src='../../images/planful-latest-logov3.png' alt="Planful" />
                    </Link>
                    {data.unsubscribeHeader &&
                        <h1>{data.unsubscribeHeader}</h1>
                    }
                    {data.unsubscribeMarketoForm &&
                        <MarketoFormComponent filterEmail="yes" indItem={indItem} formSubmitMessage={data.unsubscribeMarketoFormThankYouMessage} formId={data.unsubscribeMarketoForm} />
                    }
                </div>
                <div className="cp-flexibleUnsubscribe__footer l--flex">
                    <Link to={`/`}>
                        <StaticImage src='../../images/planful-latest-logov3.png' alt="Planful" />
                    </Link>
                    <span>@ {new Date().getFullYear()} Planful. All rights reserved</span>
                    <div className="cp-footer__bottom-social l--social l--flex">
                        <a className="l--genericBorderRadius l--flex" href="https://www.linkedin.com/company/planful-inc" target="_blank" rel="noreferrer" aria-label="LinkedIn, opens in a new tab">
                            <StaticImage src='../../images/linkedin-blue-v2.svg' alt="LinkedIn" />
                        </a>
                        <a className="l--genericBorderRadius l--flex" href="https://twitter.com/Planful" target="_blank" rel="noreferrer" aria-label="Twitter, opens in a new tab">
                            <StaticImage src='../../images/twitter-blue.svg' alt="Twitter" />
                        </a>
                        <a className="l--genericBorderRadius l--flex" href="https://www.instagram.com/planful_inc/" target="_blank" rel="noreferrer" aria-label="Instagram, opens in a new tab">
                            <StaticImage src='../../images/instagram-blue.svg' alt="Instagram" />
                        </a>
                        <a className="l--genericBorderRadius l--flex" href="https://www.facebook.com/PlanfulInc/" target="_blank" rel="noreferrer" aria-label="Facebook, opens in a new tab">
                            <StaticImage src='../../images/facebook-blue.svg' alt="Facebook" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UnsubscribePageComponent;